import { instance } from "libs/api";

import { ApiRoutesFinancialReport } from "../../constants";
import {
  FinancialPeriodParams,
  OtherCostsResponse
} from "../financialReport.types";

export const requestOtherCosts = async (
  params: FinancialPeriodParams
): Promise<OtherCostsResponse> => {
  return await instance.get(ApiRoutesFinancialReport.OtherCosts, { params });
};
